import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskChangeRequested_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import logError from 'src/utils/logError';

import ActivityLogBase from '../../Helpers/ActivityLogBase';
import ActivityLogContent from '../../Helpers/ActivityLogContent';

interface Fragments {
  activityLog: ActivityLogTaskChangeRequested_ActivityLogFragment;
}

const ActivityLogTaskChangeRequested: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;

  // eslint-disable-next-line no-underscore-dangle
  if (details?.__typename !== 'ActivityLogFlagDetails') {
    logError('ActivityLogTaskChangeRequested: details is not ActivityLogFlagDetails');
    return null;
  }

  const { flagContent } = details;

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.requestedChange"
    >
      <ActivityLogContent content={flagContent} />
    </ActivityLogBase>
  );
};

ActivityLogTaskChangeRequested.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskChangeRequested_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogFlagDetails {
          flagContent
          __typename
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskChangeRequested;
